import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import DataTable from './components/DataTable';
import UploadDrawer from './components/UploadDrawer';
import { useDispatch } from 'react-redux';
import { fetchFiltersData } from './pinCodeMappingActions';
import Loader from '../../components/Loader/Loader';

const AgencyPincodeMapping = () => {
  const dispatch = useDispatch();
  const [filtersLoader, setFiltersLoader] = useState(true);

  useEffect(() => {
    dispatch(fetchFiltersData(setFiltersLoader));
  }, []);

  const [isUploadDialogOpen, setUploadDialogOpen] = React.useState(false);

  const closeDialogue = () => setUploadDialogOpen(false);
  const openDialogue = () => setUploadDialogOpen(true);

  return (
    <>
      <DataTable openUploadDialog={openDialogue} />
      <UploadDrawer isOpen={isUploadDialogOpen} onClose={closeDialogue} />
      <Loader show={filtersLoader} className={'overlay'} animate={true} />
    </>
  );
};

export default AgencyPincodeMapping;
